export const DescriptionUnknownError =
  "Por favor, inténtalo nuevamente. Si el error persiste, comunícate con soporte.";

export const DownloadFileErrorMessage = Object.freeze({
  title: "No se pudo descargar el archivo",
  description: DescriptionUnknownError,
});

export const DownloadFileSuccessMessage = Object.freeze({
  title: "Archivo descargado",
});

export const DeleteErrorMessage = Object.freeze({
  description: DescriptionUnknownError,
});

export const SaveSuccessTitle = "Cambios guardados";

export const SaveErrorMessage = Object.freeze({
  title: "No se pudieron guardar los cambios",
  description: DescriptionUnknownError,
});
